import Vue from 'vue'
import webApiUtil from '@/common/webApiUtil'
import apiUrl from '@/common/apiUrl'
import * as _ from 'lodash'

export default {
  namespaced: true,
  state: {
    users: [],
    tempToken: null
  },
  mutations: {
    saveUserList: (state, userList) => {
      state.users = userList
    },
    setTempToken: (state, token) => {
      state.tempToken = token
    }
  },
  getters: {},
  actions: {
    userLogin: async ({rootState}, formData) => {
      rootState.isLoading = true
      const url = apiUrl.userLogin
      const res = await webApiUtil.post(url, formData)
      rootState.isLoading = false

      if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
        if (res.data.user && res.data.user.user_type === 3) {
          const _userInfo = {
            tokenId: res.data.token,
            userId: res.data.user['id'],
            expiredAt: new Date(res.data['expired_at'])
          }
          Vue.$cookies.set('userInfo', _userInfo, new Date(res.data['expired_at']))
          return res
        } else {
          return null
        }
      } else {
        return null
      }
    },
    userLogout: async ({rootState}) => {
      rootState.isLoading = true
      const url = apiUrl.userLogout
      const res = await webApiUtil.post(url, {}, {}, true)
      rootState.isLoading = false

      if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
        localStorage.removeItem('provinceList')
        localStorage.removeItem('districtList')
        localStorage.removeItem('communeList')
        localStorage.removeItem('zoneTypeList')
        Vue.$cookies.remove('userInfo')
        return res
      } else {
        return null
      }
    },
    getUserList: async ({commit, rootState}, filter) => {
      let resData = []
      try {
        rootState.isLoading = true
        const url = apiUrl.userList
        const params = {
          current_page: 1,
          page_size: 50000
        }
        _.merge(params, filter)
        const res = await webApiUtil.post(url, params)

        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          resData = res.data['users']
        } else {
          resData = []
        }
      }
      catch (e) {
        resData = []
      }
      finally {
        rootState.isLoading = false
      }

      commit('saveUserList', resData)
    },
    requestVerifyCode: async ({rootState}, userName) => {
      try {
        rootState.isLoading = true
        const url = apiUrl.requestVerifyCode
        const param = {
          name: userName
        }
        const res = await webApiUtil.post(url, param)
        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          const getVerifyCode = {
            user_id: res.data.user.id,
            message: res.data.message,
            timeout: 300,
            maxTimeout: 300
          }
          localStorage.setItem('getVerifyCodeData', JSON.stringify(getVerifyCode))
          return res
        } else {
          return null
        }
      } catch (e) {
        return null
      } finally {
        rootState.isLoading = false
      }
    },
    onCompareVerifyCode: async ({commit, rootState}, param) => {
      try {
        rootState.isLoading = true
        const url = apiUrl.verifyCode
        const res = await webApiUtil.post(url, param)
        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          commit('setTempToken', res.data.token)
          return true
        } else {
          return null
        }
      } catch (e) {
        return null
      } finally {
        rootState.isLoading = false
      }
    },
    onChangePw: async ({rootState}, data) => {
      try {
        rootState.isLoading = true
        const url = apiUrl.userChangePw
        const res = await webApiUtil.post(url, data._param, data._config)
        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          return res
        } else {
          return null
        }
      } catch (e) {
        return null
      } finally {
        rootState.isLoading = false
      }
    },
    resetTempToken: ({commit}) => {
      commit('setTempToken', null)
    },
    // eslint-disable-next-line no-unused-vars
    userUpdateToken: async (context) => {
      if (Vue.$cookies.isKey('userInfo')) {
        const url = apiUrl.updateToken
        const res = await webApiUtil.post(url, {}, {}, true)

        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          const _userInfo = {
            tokenId: res.data.token,
            userId: Vue.$cookies.get('userInfo')['userId'],
            expiredAt: new Date(res.data['expired_at'])
          }
          Vue.$cookies.set('userInfo', _userInfo, new Date(res.data['expired_at']))
        }
      } else {
        await this.$router.push({
          name: 'Login',
          params: {
            pathName: 'userUpdateToken'
          },
          query: {
            isExpired: true
          }
        })
      }
    }
  }
}
